import React, { useEffect, useState } from "react";
import { InputFieldContainer, InputLabel, InputArea } from "./InputFieldStyles";
import { H5 } from "../../theme/text";
import { color } from "../../theme/standardTheme";

const InputField = (props) => {

    const [localValue, setLocalValue] = useState(props.value);

    useEffect(() => {
        setLocalValue(props.value);
    }, [props.value]);

    function refresh(event, val) {
        event.stopPropagation();
        setLocalValue(val);
    }

    function update(event, val) {
        event.stopPropagation();
        setLocalValue(props.value);
        props.update(val);
    }

    return (
        <InputFieldContainer maxWidth={props.maxWidth} style={props.style}>
            {props.label?<H5 style={{margin: "0px 10px", justifySelf: "end", color: color.fontSecondary}}>{props.label}</H5>:<></>}
            <InputArea
                type = {props.type}
                pattern={props.pattern}
                onChange={(event) => {refresh(event, event.target.value)}}
                onBlur = {(event) => {update(event, event.target.value)}}
                value={localValue}
                onClick={(event) => refresh(event, '')}
                maxWidth = {props.maxWidth}
                placeholder = {props.placeholder || "0"}
                autocomplete={props.autocomplete || "off"}
                id={props.id || ""}
            />
        </InputFieldContainer>
    );
}

export default InputField;